export const apiHost = {
    // baseURL: "https://api.daqi.in/api/"
   baseURL: "https://dev-api.daqi.in/api/"
};